import { DEFAULT_ANIMATION_SPEED } from '@src/config/imageSettings';

/**
 * Value helpers for the element settings panel's fields (PLAT-12137).
 * docs/design-system.md § "Panel Fields".
 */

const DISPLAY_FORMAT = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  useGrouping: false,
});

/**
 * At most two decimals, no grouping: "3.878875" reads "3.88". Display only; the
 * stored value is untouched until the person types a new one.
 */
export const formatPanelNumber = (value: unknown): string => {
  if (value === '' || value === null || value === undefined) return '';
  const n = Number(value);
  return Number.isFinite(n) ? DISPLAY_FORMAT.format(n) : String(value);
};

/** "35%" → 35; missing or unparseable → the fallback. 0 stays 0. */
export const percentOr = (value: unknown, fallback: number): number => {
  const n = parseFloat(String(value));
  return Number.isNaN(n) ? fallback : n;
};

/**
 * The four element-animation speeds, as the scale an animation ends on. They
 * were the old tick slider's four named ticks; the values between them had no
 * name and no visible difference worth the precision.
 */
export const SPEED_PRESETS = [
  { id: '108', label: 'Very Slow' },
  { id: '118', label: 'Slow' },
  { id: '130', label: 'Normal' },
  { id: '140', label: 'Fast' },
];

/** The preset closest to an element's stored speed ("110%" reads Very Slow). */
export const nearestSpeedPreset = (
  speed: string | null | undefined,
): string => {
  const n = parseFloat(speed || DEFAULT_ANIMATION_SPEED);
  return SPEED_PRESETS.reduce((best, p) =>
    Math.abs(Number(p.id) - n) < Math.abs(Number(best.id) - n) ? p : best,
  ).id;
};
